// extracted by mini-css-extract-plugin
export default {"fieldset":"PaymentMethodView_fieldset__WvVIL","label":"PaymentMethodView_label__GzE2Z","input":"PaymentMethodView_input__xCI2B","select":"PaymentMethodView_select__CFwfT"};